import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getModalCloseUtilityClass(slot) {
  return generateUtilityClass('JoyModalClose', slot);
}
const modalCloseClasses = generateUtilityClasses('JoyModalClose', ['root', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'variantPlain', 'variantOutlined', 'variantSoft', 'variantSolid', 'sizeSm', 'sizeMd', 'sizeLg']);
export default modalCloseClasses;